import { z } from 'zod';

export const CloverCardTransactionRecordSchema: z.ZodRecord<
    z.ZodString,
    z.ZodUnknown
> = z.record(z.string(), z.unknown());

export function omitEmptyCloverCardTransactionText(
    value: unknown
): unknown {
    const recordResult = CloverCardTransactionRecordSchema.safeParse(value);
    if (!recordResult.success) {
        return value;
    }
    const { cardholderName, token, ...otherFields } = recordResult.data;
    return {
        ...otherFields,
        ...(cardholderName === undefined || cardholderName === ''
            ? {}
            : { cardholderName }),
        ...(token === undefined || token === '' ? {} : { token }),
    };
}
